<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-video-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.video.create') }}</h4>
        </template>
        <template v-slot:body>
            <VideoForm :video-prop="video" @change="onChangeVideo" :hide-visibility-video="true"></VideoForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewVideo(video.title, video.description, video.language)">
                <i class="las la-check"></i>
                {{ $t('components.video.create') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    // TODO add check fields
    import {LANGUAGE_OPTIONS, VIDEO_VISIBILITY} from "../../common/constants";
    import {createVideo} from "../../api";
    import VideoForm from "../video/VideoForm";
    import ModalContainer from "./ModalContainer";
    import {LocaleHelper} from "../../common/localeHelper";
    export default {
        name: "AddVideoModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                video: {
                    id: null,
                    title: "",
                    description: "",
                    video_id: null,
                    language: LocaleHelper.getLanguage(),
                    visibility: VIDEO_VISIBILITY.NOT_PUBLIC,

                },
                languageOptions: LANGUAGE_OPTIONS(),
                errorMessage: ""
            }
        },
        components: {VideoForm, ModalContainer},
        methods: {
            async createNewVideo(newVideoTitle, newVideoDescription, newVideoLanguage) {
                this.loading = true;
                try {
                    const resultVideo = await createVideo(newVideoTitle, newVideoDescription, newVideoLanguage);
                    this.loading = false;
                    this.$emit('close-video-modal');
                    this.$nextTick(() => {
                        this.$router.push({ name: 'video_detail', params: { video_id: resultVideo.id }});
                    });


                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeVideo(video) {
                this.video = video;
            }
        }
    };
</script>
